module.exports = __webpack_public_path__ + "static/media/e10.e617f4d9.jpg";